export const ENDPOINT_GET_STATIC_APPROVERS = '/staticdata/GetApproverOverrides';
export default function TripCheckoutService(
    $http,
    refreshTravellerDetailsService
) {
    'ngInject';
    const vm = this;

    Object.assign(vm, {
        checkTravellerDetailsChanges,
        getStaticApprovers,
    });

    function checkTravellerDetailsChanges(travellers) {
        return refreshTravellerDetailsService.checkTravellerDetailsChanges(travellers);
    }
    function getStaticApprovers(code) {
        return $http.apiGET(ENDPOINT_GET_STATIC_APPROVERS, {params: {paymentCodeId: code}})
                    .then((response) => (response));
        }

}



// WEBPACK FOOTER //
// ./src/app/modules/trip/checkout/trip-checkout-service.js